import React from 'react';
import CloroxIndicators from 'components/Tvendo/Sale/QuotaBPartner/Clorox/IndicatorsClorox/List.js';

export default function () {
  return <CloroxIndicators />;
}
